import List from 'units/AdminCreatedUser/units/List'
import Add from 'units/AdminCreatedUser/units/Add'

import {
  getCountries,
  setSelectionsCountry,
} from 'reduxpath/ducks/Reference'

import { getAdminCreatedUsers } from 'reduxpath/ducks/AdminCreatedUser/List'
import { initState } from 'reduxpath/ducks/AdminCreatedUser/Add'

const list = (store) => {
  store.dispatch(
    getAdminCreatedUsers({
      sort: 'name ASC',
      limit: 10,
      skip: 0,
      where: {
        source: 'admin',
        hasAgreedTnc: 'false',
      },
    }),
  )
}

function add(store) {
  store.dispatch(
    getCountries((countries) => {
      store.dispatch(setSelectionsCountry(countries.rows))
      store.dispatch(initState())
    }),
  )
}

export default {
  populate: {
    list,
    add,
  },
  components: {
    List,
    Add,
  },
}
